import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SuperAdminAuthContext = createContext(null);

export const SuperAdminAuthProvider = ({ children }) => {
    const [superAdmin, setSuperAdmin] = useState(() => {
        const adminData = localStorage.getItem('superAdminInfo');
        return adminData ? JSON.parse(adminData) : null;
    });
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchSession = async () => {
        const token = localStorage.getItem('superAdminToken');
        if (!token) {
            setLoading(false);
            return;
        }

        try {
            const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
            const res = await axios.get(`${API_BASE}/superadmin/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data && res.data.admin) {
                const adminData = res.data.admin;
                setSuperAdmin(adminData);
                localStorage.setItem('superAdminInfo', JSON.stringify(adminData));
            }
        } catch (error) {
            console.error('Session verification failed:', error.message);
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                logout();
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSession();
    }, []);

    const login = (token, adminInfo, mustChangePassword = false) => {
        localStorage.setItem('superAdminToken', token);
        localStorage.setItem('superAdminInfo', JSON.stringify(adminInfo));
        setSuperAdmin(adminInfo);

        if (mustChangePassword) {
            navigate('/superadmin/first-time-password-reset');
        } else {
            navigate('/superadmin/dashboard');
        }
    };

    const updateSuperAdminData = (updatedInfo) => {
        const merged = { ...superAdmin, ...updatedInfo };
        localStorage.setItem('superAdminInfo', JSON.stringify(merged));
        setSuperAdmin(merged);
    };

    const logout = () => {
        localStorage.removeItem('superAdminToken');
        localStorage.removeItem('superAdminInfo');
        setSuperAdmin(null);
        navigate('/superadmin/login');
    };

    return (
        <SuperAdminAuthContext.Provider value={{
            superAdmin,
            loading,
            login,
            logout,
            fetchSession,
            updateSuperAdminData
        }}>
            {children}
        </SuperAdminAuthContext.Provider>
    );
};

export const useSuperAdminAuth = () => useContext(SuperAdminAuthContext);
